<template>
	<div>
		<locum-availability-deleted />
		<locum-upcoming-bookings />
		<locum-past-bookings />
		<locum-increase-availability-ad />
	</div>
</template>

<script>
import LocumAvailabilityDeleted from '@/components/ui/dashboard/locum/cards/LocumAvailabilityDeleted';
import LocumUpcomingBookings from '@/components/ui/dashboard/locum/dropdowns/LocumUpcomingBookings';
import LocumPastBookings from '@/components/ui/dashboard/locum/dropdowns/LocumPastBookings';

import LocumIncreaseAvailabilityAd from '@/components/ui/dashboard/locum/cards/LocumIncreaseAvailabilityAd';

export default {
	name: 'LocumSuccessAvailabilityDeleted',
	components: {
		LocumAvailabilityDeleted,
		LocumUpcomingBookings,
		LocumPastBookings,
		LocumIncreaseAvailabilityAd,
	},
	data: () => ({}),
};
</script>
